<template>
  <div class="allergen-table mt-8">
    <table>
      <tr>
        <td><img src="https://madoheusden.be/img/egg.png" alt="egg" /></td>
        <td>{{ this.translations["ei"][this.$route.query.lang] }}</td>
      </tr>
      <tr>
        <td>
          <img src="https://madoheusden.be/img/gluten.png" alt="gluten" />
        </td>
        <td>{{ this.translations["gluten"][this.$route.query.lang] }}</td>
      </tr>
      <tr>
        <td><img src="https://madoheusden.be/img/milk.png" alt="egg" /></td>
        <td>{{ this.translations["zuivel"][this.$route.query.lang] }}</td>
      </tr>
      <tr>
        <td><img src="https://madoheusden.be/img/nuts.png" alt="egg" /></td>
        <td>{{ this.translations["noten"][this.$route.query.lang] }}</td>
      </tr>
      <tr>
        <td><img src="https://madoheusden.be/img/sesame.png" alt="egg" /></td>
        <td>{{ this.translations["sesam"][this.$route.query.lang] }}</td>
      </tr>
      <tr>
        <td><img src="https://madoheusden.be/img/soy.png" alt="egg" /></td>
        <td>{{ this.translations["soya"][this.$route.query.lang] }}</td>
      </tr>
      <tr>
        <td><img src="https://madoheusden.be/img/mustard.png" alt="egg" /></td>
        <td>{{ this.translations["mosterd"][this.$route.query.lang] }}</td>
      </tr>
      <tr>
        <td><img src="https://madoheusden.be/img/fish.png" alt="egg" /></td>
        <td>{{ this.translations["vis"][this.$route.query.lang] }}</td>
      </tr>
      <tr>
        <td><img src="https://madoheusden.be/img/lupin.png" alt="egg" /></td>
        <td>{{ this.translations["lupine"][this.$route.query.lang] }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      translations: {
        ei: {
          nl: "Ei",
          en: "Egg",
          tr: "Yumurta",
        },
        gluten: {
          nl: "Gluten",
          en: "Gluten",
          tr: "Gluten",
        },
        zuivel: {
          nl: "Zuivel",
          en: "Dairy",
          tr: "Süt Ürünleri",
        },
        noten: {
          nl: "Noten",
          en: "Nuts",
          tr: "Kuruyemiş",
        },
        sesam: {
          nl: "Sesam",
          en: "Sesame",
          tr: "Susam",
        },
        soya: {
          nl: "Soya",
          en: "Soy",
          tr: "Soya",
        },
        mosterd: {
          nl: "Mosterd",
          en: "Mustard",
          tr: "Hardal",
        },
        vis: {
          nl: "Vis",
          en: "Fish",
          tr: "Balık",
        },
        lupine: {
          nl: "Lupine",
          en: "Lupin",
          tr: "Bakla",
        },
      },
    };
  },
};
</script>

<style>
.allergen-table {
  margin-top: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

td {
  padding-right: 2.5rem;
  padding-left: 2.5rem;
  padding-bottom: 2rem;
}
</style>
